// extracted by mini-css-extract-plugin
export default {"wrapper":"CenterAuthStructure_wrapper__R47uV","auth-wrapper":"CenterAuthStructure_auth-wrapper__0bYFI"};